import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ChangeDetectorRef, } from '@angular/core';
import { ModalComponent } from 'lib/modal/modal.component';
//import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer-ng2',
  templateUrl: './pdf-viewer-ng2.component.html',
  styleUrls: ['./pdf-viewer-ng2.component.scss']
})
export class PdfViewerNg2Component implements OnInit {
  @Input() modalTitle: any;

  //https://itnext.io/you-dont-need-external-packages-to-view-pdf-in-angular-e47779f86595
  @Input() pdfFilePathNew: any;
  //urlSafe: SafeResourceUrl;

  @ViewChild('childModal', { static: false }) childModal: ModalComponent;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) { }//, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    ////https://stackoverflow.com/a/74444844
    //this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfFilePathNew);
  }

  open() {
    //setTimeout(() => {
    //  this.childModal.show();
    //}, 500);
    this.childModal.show();
    this.cd.markForCheck();
  }

  ////https://stackoverflow.com/questions/54450358/ng2-pdf-viewer-problems-with-render-large-pdf-over-300pages
  //totalPages: number;
  //page: number = 1;
  //isLoaded: boolean = false;

  //nextPage() {
  //  this.page += 1;
  //}

  //previousPage() {
  //  this.page -= 1;
  //}

  //afterLoadComplete(pdfData: any) {
  //  this.totalPages = pdfData.numPages;
  //  this.isLoaded = true;
  //}

}
